import { render, staticRenderFns } from "./TableCategory.vue?vue&type=template&id=2db4926e&"
import script from "./TableCategory.vue?vue&type=script&lang=js&"
export * from "./TableCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports